import { Toast } from 'antd-mobile';
export const notifyError = (msg) => {
    const text = msg || '操作失败';
    const isMobile = window.innerWidth <= 768 ||
        navigator.userAgent.includes('Mobile');
    if (isMobile) {
        Toast.show({ content: text });
    }
    else {
        Toast.show(text);
    }
};
